import { render, staticRenderFns } from "./ClaimStartCard.vue?vue&type=template&id=a9297774&scoped=true"
import script from "./ClaimStartCard.vue?vue&type=script&lang=js"
export * from "./ClaimStartCard.vue?vue&type=script&lang=js"
import style0 from "./ClaimStartCard.vue?vue&type=style&index=0&id=a9297774&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9297774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9297774')) {
      api.createRecord('a9297774', component.options)
    } else {
      api.reload('a9297774', component.options)
    }
    module.hot.accept("./ClaimStartCard.vue?vue&type=template&id=a9297774&scoped=true", function () {
      api.rerender('a9297774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/medicaid/claims/components/ClaimStartCard.vue"
export default component.exports